export function determineLifePackageTitle(packageCode: string): string {
    switch (packageCode) {
        case 'mini':
            return 'eshop.life.packages.mini';
        case 'midi':
            return 'eshop.life.packages.midi';
        case 'maxi':
            return 'eshop.life.packages.maxi';
        case 'free':
            return 'eshop.life.packages.free';
        default:
            return packageCode;
    }
}
